import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import { BigNumber } from 'bignumber.js'

// Styles
import styles from './style.module.scss'
import { useDiscountRate } from '@/hooks/useDiscountRate'

const cx = classnames.bind(styles)

interface IProps {
  price: number
  origPrice: number
  isMobile?: boolean
}

const defaultProps = {
  isMobile: false,
}

const Price = (props: IProps) => {
  const { price, origPrice, isMobile } = props
  const { t } = useTranslation()
  const discountRate = useDiscountRate(price, origPrice)

  return (
    <div className={cx('price')}>
      <div className={cx('price-label')}>{t('Common_Live_Price')}</div>
      <div className={cx('price-content', { 'price-content--mobile': isMobile })}>
        {price < origPrice && <div className={cx('discount')}>{t('Common_Discount_Plummet_Price', { discountRate })}</div>}
        <div className={cx('discount-price')}>$ {new BigNumber(price).toFormat()}</div>
      </div>
    </div>
  )
}

Price.defaultProps = defaultProps
export default Price
